var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#0d2135}.cls-6{fill:#de9885}.cls-7{fill:#61372c}.cls-10{fill:#efb7a8}.cls-11{fill:#dfefff}.cls-16{fill:#94c9fd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.84 140.13A169.43 169.43 0 0198.41 309.55V140.13z",
    fill: "#dc6240"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.16,
    y: 137.08,
    width: 40.65,
    height: 3.08,
    rx: 1.42,
    transform: "rotate(180 131.49 138.62)",
    fill: "#394450"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 134.37,
    y: 118.77,
    width: 40.73,
    height: 3.08,
    rx: 1.42,
    transform: "rotate(-76.28 154.728 120.313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.82 187.4l-18.58.23c-11.21 0-17.94-11.92-19.83-23.19l-7.16-42.86C14.31 106.75 5 104.19 5 104.19s4.17 39.27 7.71 72.68c2.57 24.28 15.64 24.68 51.45 23.08 6.94-.31 9.4-12.78-1.34-12.55z",
    fill: "#b4c6d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 310L19 208.32a9.25 9.25 0 019.18-7.59H60a9.24 9.24 0 019.17 7.59L79 310",
    strokeWidth: 0.79,
    strokeMiterlimit: 10,
    stroke: "#0d2135",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M50.8 260.38l3.61-3.83 8.12 7.23c-2.23 2.16-2.41 3.65-2.41 3.65l-3.69 4.44-7.94-6.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.8 260.38l-7.49 4.33a3.38 3.38 0 00-.74 5.27l16.19 16.72a11.45 11.45 0 005.36 3.22A2.47 2.47 0 0067 288.5a2.48 2.48 0 00-.27-2.44c-5.7-7.88-6.6-18.63-6.6-18.63-11.69.88-9.33-7.05-9.33-7.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b4481",
    d: "M98.61 202.43l-44.2 54.12 20.14 19.07 41.15-56.16-17.09-17.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3 155.29s31.08 21.1 40.65 29.27c6.27 5.34 10.4 10.71 11.87 18.84l12.9 70.92-28.21 3.22-9.21-60.18c-.6-4-5.3-9.37-8.41-11.89-19.38-15.68-31.65-17-43.26-16.73-12.94.26-16.92-6.74-19.32-11.52-3.17-6.28-.19-19.52-.19-19.52l43.76-8.16z",
    fill: "#2a67b2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.36 283.55l-.85-6 11.55-1.67c.35 3.09.73 17.2.73 17.2l-10.74-2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M115.68 286l-5.77 6.47a3.37 3.37 0 001 5.23l20.61 10.76a11.61 11.61 0 006.1 1.36 2.47 2.47 0 002.28-2.26 2.47 2.47 0 00-1-2.22c-7.89-5.68-12.11-15.59-12.11-15.59-10.88 4.56-11.11-3.75-11.11-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M88 52c-.05.42-.11.85-.19 1.28q-.06.38-.15.75A19.72 19.72 0 0164.09 69c-.36-.08-.73-.17-1.08-.27A19.8 19.8 0 1188 51.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M45.89 81.89l26.47 5.35s-2.94-13 3.93-13.82 7.23-.93 8.48-7.19c.55-3.55 3.2-2.48 3.65-4.51s-1.37-4.89-.38-9.86L50 56.61c4.37 11.76 7.6 15.61-4.41 25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M78.26 151.76c.6-23.91 2-47.63-6-65.8a41 41 0 01-21.77-8.58l-4.32 5.5c-4.64 6-5.54 18.65-7.31 26.2-3.18 10.84 4.35 12.85-1.62 33.74a126.12 126.12 0 00-3.52 15.3c9.18-2.12 44.54-6.12 44.54-6.36z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.98,
    strokeMiterlimit: 10,
    stroke: "#0d2135",
    fill: "none",
    d: "M86.63 52.15l-1.45 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.72 55.73l-11-3.14.11-.48 11.26 2.05-.37 1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.58 44.93c-1.34 2-4.69 6.3-9 7 0 0 2-1.15 3.71-6.07a24.82 24.82 0 01-6.7 7.57 17.26 17.26 0 01-2.76 1.66l-3.4-.89-7.13-1.85a12 12 0 000 2.73c.35 3.47 1.38 8.74.73 13.64a13.38 13.38 0 01-4.55 9 12.43 12.43 0 00-4 6.12c-2.52 7.41.46 14-8.74 18.13-6.43 2.89-7.22 8.38-7.12 13.56.08 4.3 1.7 8.82.92 12.18-28.11-15-7.52-38.49-9-44.47C23.6 67.58 45.93 58 49.2 45.37a19.72 19.72 0 0138.38-.44z",
    fill: "#be3626"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 67.72,
    cy: 52.91,
    rx: 5.52,
    ry: 5.5,
    transform: "rotate(-83.98 67.717 52.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M69.96 128.43l20.26.76-2.9 18.19-17.97 2.28.61-21.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M132 125.11l-.1.37c-.26.91-.53 1.1-1.79 1.39a59.24 59.24 0 01-7.09.52c0 1.43-.25 8.24-6.87 9.35l-7.68 1.07-20.1 3 1.86-11.65 17.13.38 7.06.12a3.82 3.82 0 002.7-1l3.75-3.47a1.63 1.63 0 011.17-.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M122 127l8.21 2.12a3 3 0 01-3.18 1.16l-5.83-.58z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.51,
    cy: 27.75,
    r: 4.14,
    fill: "#fbebd3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#94c9fd",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    fill: "none",
    d: "M202.31 10.54l18.13 77.07-23.63 52.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M195.11 38.46l-21.28-21.27a15 15 0 0114.92-3.79 5.88 5.88 0 005.76-1.55l1.84-1.85 6 5.94-1.85 1.85a5.86 5.86 0 00-1.55 5.76 15 15 0 01-3.84 14.91z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 200.25,
    cy: 11.92,
    r: 1.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 220.19,
    cy: 88.09,
    r: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M207.93 136.18h-20.14a4.18 4.18 0 00-4.18 4.18h28.5a4.18 4.18 0 00-4.18-4.18z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h400v320H0z",
    id: "Layer_3",
    "data-name": "Layer 3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.b869098e4d987f64745bbcaebb16fdf1.svg";
export { ForwardRef as ReactComponent };